import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { useEffect } from 'react';
import { PageMessage } from 'components/GlobalUI';
import { MessageType } from '@upstart/harmony/lib/legos/websiteTypes';
import FontsList from '../../components/FontsList';
import fontActions from '../../redux/fonts/actions';
import SidebarContainer from '../SidebarContainer';
import './Fonts.scss';

function Fonts({ fonts, actions }) {
  useEffect(() => {
    actions.availableFontsRequest();
  }, [actions]);

  const onSuccess = () =>
    PageMessage({
      message: 'Font successfully uploaded',
      type: MessageType.SUCCESS,
    });

  const onError = () =>
    PageMessage({
      message: 'Error uploading font',
      type: MessageType.ERROR,
    });

  return (
    <SidebarContainer title="Fonts" openSubMenu="Client Management">
      <div className="fonts-table">
        <FontsList
          list={fonts?.availableFonts}
          upload={{
            action: actions.createFontRequest,
            onError,
            onSuccess,
          }}
        />
      </div>
    </SidebarContainer>
  );
}

Fonts.propTypes = {
  fonts: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ fonts }) => ({ fonts });

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...fontActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Fonts);
